export default __webpack_public_path__ + "static/81859-a2ea6d18693a7ebe75b94219b49b8bcd.jpg";